var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHatXmasSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 469.333 469.333",
    xmlSpace: "preserve",
    fill: "#000000",
    transform: "matrix(-1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1004.36)",
    shapeRendering: "auto",
    imageRendering: "auto",
    colorRendering: "auto",
    colorInterpolation: "sRGB"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B322E"
    },
    d: "M235.234,1009.703c-0.355-0.018-0.711-0.018-1.067,0c-1.957,0.111-3.846,0.76-5.459,1.875 L58.854,1128.39c-3.502-0.822-7.113-1.354-10.854-1.354c-26.383,0-48,21.617-48,48c0,26.383,21.617,48.001,48,48.001 c25.634,0,46.591-20.456,47.772-45.813l37.207-13.542l-66,198.021H53.333c-29.362,0-53.333,23.971-53.333,53.333 c0,29.362,23.971,53.333,53.333,53.333H416c29.362,0,53.333-23.971,53.333-53.333c0-29.362-23.971-53.333-53.333-53.333h-14.458 l-157.084-345.751c-1.651-3.661-5.217-6.084-9.229-6.271L235.234,1009.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA6153"
    },
    d: "M230.317,1036.391l147.792,325.334H89.464l69.104-207.313l47.604-17.312 c5.557-1.956,8.477-8.047,6.521-13.604c-1.49-4.234-5.471-7.082-9.959-7.126l0,0c-1.314-0.019-2.621,0.206-3.854,0.661 l-106.917,38.874c-2.743-6.256-6.858-11.71-11.854-16.249l150.208-103.292L230.317,1036.391z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEFEF"
    },
    d: "M48.004,1148.391c14.854,0,26.667,11.813,26.667,26.667c0,14.854-11.812,26.667-26.667,26.667 c-14.853,0-26.667-11.813-26.667-26.667S33.151,1148.392,48.004,1148.391L48.004,1148.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFEFEF"
    },
    d: "M53.338,1383.058c120.657,0.117,241.906,0,362.667,0c17.913,0,32,14.087,32,32 c0,17.913-14.087,32-32,32H53.338c-17.913,0-32-14.087-32-32C21.338,1397.146,35.425,1383.058,53.338,1383.058z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BB4E42"
    },
    d: "M230.317,1036.37l-11.5,7.917l144.208,317.438h15.084l-147.792-325.333l0,0L230.317,1036.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BB4E42"
    },
    d: "M187.65,1116.37c-1.314,0-2.621,0.202-3.854,0.661l-94.208,34.251 c0.875,1.489,1.675,3.028,2.374,4.625l102.251-37.188c-1.862-1.497-4.174-2.326-6.563-2.354L187.65,1116.37z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBFBF"
    },
    d: "M48.004,1148.391c-2.641,0-5.141,0.491-7.541,1.188c11.094,3.227,19.125,13.267,19.125,25.479 c0,12.212-8.031,22.253-19.125,25.479c2.4,0.704,4.9,1.189,7.541,1.189c14.854,0,26.667-11.813,26.667-26.667 S62.859,1148.392,48.004,1148.391L48.004,1148.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFBFBF"
    },
    d: "M400.922,1383.058c17.913,0,32,14.087,32,32c0,17.913-14.087,32-32,32h15.083 c17.913,0,32-14.087,32-32c0-17.913-14.087-32-32-32H400.922z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatXmasSvgrepoCom);
export default __webpack_public_path__ + "static/media/hat-xmas-svgrepo-com.cd3bc75b9350393afbeab21b5f00fd1a.svg";
export { ForwardRef as ReactComponent };